<template>
  <li class="dropdown-nav-item nav-item" @pointerenter="open = true" @pointerleave="open = false">
    <div class="dropdown-nav-toggle" @click="open = false">
      <router-link :to="toggleTo">{{toggleText}}</router-link>
    </div>
    <transition name="fade-in">
      <div class="dropdown-nav-content" v-if="open" @click="open = false">
        <slot/>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'Dropdown',

  data() {
    return {
      open: false,
    };
  },

  props: {
    toggleTo: {
      type: String,
      required: true,
    },

    toggleText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  .dropdown-nav-item {
    width: auto;
    min-width: 12.5rem;

    position: relative;

    .dropdown-nav-toggle {
      text-align: center;

      a {
        text-decoration: none;

        position: relative;
        top: -5px;

        &.router-link-active {
          color: rgba(255, 255, 255, 0.7);
        }
      }

      &::after {
        content: none;
      }
    }

    .dropdown-nav-content {
      position: absolute;
      left: 0;
      top: 55px;

      width: 100%;
      padding: 0;

      border-color: rgba(255, 251, 243, 0.4);
      border-radius: 2px;
      border-width: 1px;
      border-style: solid;

      transition: background-color 350ms ease, border-color 350ms ease, height 350ms ease;

      background-color: rgba(255, 251, 243, 0.5);

      letter-spacing: 1px;

      overflow: hidden;
    }

    &.solid {
      .dropdown-nav-toggle > a {
        color: black;

        &.router-link-active {
          color: rgba(0, 0, 0, 0.5);
        }
      }

      .dropdown-nav-content {
        background-color: $body-bg;
        border-color: rgba(0, 0, 0, 0.35);
      }
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fade-in-enter-active {
    animation: fade-in 350ms ease-in-out;
    transform-origin: 50% 0;
  }

  .fade-in-leave-active {
    animation: fade-in 350ms ease-in-out reverse;
    transform-origin: 50% 0;
  }
</style>
